import {SignUpComponent} from "../SignUpComponent.js";
import {InputErrorHandler} from "../../util/input-error-handler/index.js";

export class Select extends SignUpComponent {
    getOptionsTemplate() {
        return this.getOptionsDataArr().map((optionData) => this.getOptionTemplate(optionData)).join(' ');
    }


    getOptionsDataArr() {
        return [];
    }

    getOptionTemplate(optionData) {
        if(optionData.value === "") return `<option selected value="${optionData.value}">${optionData.text}</option>`
        return `<option value="${optionData.value}">${optionData.text}</option>`
    }

    setEvent() {
        this.addEvent("click.stop", this.getQuerySelectorOfSelect(),(e) => {
            InputErrorHandler.unActiveErrorModeAboutInput($(e.target));
        });

        this.addEvent("change", this.getQuerySelectorOfSelect(), () => {
            const $select = $(`${this.getQuerySelectorOfSelect()}`);
            if(this.getSelectValue().length === 0) {
                $select.hasClass("active")  && $select.removeClass("active");
                return;
            }
            !$select.hasClass("active")  && $select.addClass("active");

        } );
        this.interactiveFormFunc()

    }

    getQuerySelectorOfSelect() {
        return `select`;
    }
    getSelectValue() {
        return $(this.getQuerySelectorOfSelect()).val();
    }

}